import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const RadioWrapper = styled.div`
	margin-bottom: ${theme.space_size};
`;
